import * as React from "react";
import type { SVGProps } from "react";

interface VideoReviewProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const VideoReview = ({ cancelled = false, ...props }: VideoReviewProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(2.5 7)">
        <rect
          width={21.25}
          height={13.25}
          x={-1.13}
          y={-1.13}
          fill="#FFF"
          stroke="#FFF"
          strokeWidth={2.25}
          rx={0.5}
        />
        <rect
          width={20.3}
          height={12.3}
          x={-0.65}
          y={-0.65}
          stroke="#000"
          strokeWidth={1.3}
          rx={0.5}
        />
      </g>
      <path
        fill="#000"
        fillRule="nonzero"
        d="M6.52 16.03a.9.9 0 0 1-.46-.13.7.7 0 0 1-.31-.38l-1.8-5.14c-.08-.21-.08-.38 0-.5s.25-.18.5-.18c.35 0 .57.16.68.49l1.38 4.23 1.4-4.23c.1-.33.34-.49.7-.49.2 0 .36.06.45.18.08.13.1.3.02.5l-1.8 5.14a.7.7 0 0 1-.3.38.9.9 0 0 1-.46.13M9.4 16c-.2 0-.33-.06-.4-.17-.08-.12-.08-.27-.01-.47l1.96-5.22c.11-.3.32-.44.64-.44h.08c.32 0 .53.15.64.44l1.96 5.22c.07.2.07.36 0 .47-.08.11-.21.17-.41.17h-.2c-.3 0-.52-.15-.62-.46l-.27-.8h-2.31l-.27.8c-.1.3-.3.46-.63.46h-.17Zm1.43-2.33h1.57l-.77-2.29zM15.78 16c-.4 0-.59-.2-.59-.6v-5.1q0-.6.6-.6h2.32c.4 0 .74.06 1.03.18s.51.31.67.58.24.64.24 1.1c0 .56-.12.98-.36 1.27-.25.28-.58.46-1 .54l.93 1.93c.1.2.12.37.06.5-.07.13-.2.2-.4.2h-.18a.7.7 0 0 1-.7-.45l-.91-2.12h-1.13v1.98c0 .4-.2.59-.58.59m.58-3.66h1.58c.27 0 .49-.06.64-.18q.24-.18.24-.6t-.24-.6a1.02 1.02 0 0 0-.64-.18h-1.58z"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default VideoReview;
